import { RulesComponent } from '@/rules-management/primary/RulesComponent.tsx';
import { useInitOnce } from '@/generic/init';
import {
  PROVIDE_RULES_MANAGEMENT,
  provideRulesManagement,
} from '@/rules-management/RulesManagementProvider.ts';

export const RulesApp = () => {
  useInitOnce(PROVIDE_RULES_MANAGEMENT, provideRulesManagement);
  return <RulesComponent />;
};
